import { Route, Routes } from "react-router-dom";
import { QuoterPage } from "./pages/QuoterPage";
import { QuoterHistoryPage } from "./pages/QuoterHistoryPage";

export const QuoterNavigation = () => (
  <Routes>
    <Route index element={<QuoterPage />} />
    <Route path="history" element={<QuoterHistoryPage />} />
  </Routes>
);
